<template>
  <v-navigation-drawer
    v-if="authStore.isAuthenticated"
    v-model="drawer"
    temporary
    color="background"
    elevation="2"
    width="280"
  >
    <v-list density="compact" nav>
      <v-list-item
        prepend-icon="mdi-home"
        :title="$t('nav.home')"
        value="home"
        to="/"
        exact
        @click="closeDrawer"
      />
      
      <v-list-item
        prepend-icon="mdi-account"
        :title="$t('profile.title')"
        value="profile"
        to="/profile"
        @click="closeDrawer"
      />
      
      <template v-if="authStore.isAdmin">
        <v-divider class="my-2" />
        
        <v-list-subheader>{{ $t('nav.admin') }}</v-list-subheader>
        
        <v-list-item
          prepend-icon="mdi-account-group"
          :title="$t('users.title')"
          value="users"
          to="/users"
          @click="closeDrawer"
        />
        
        <v-list-item
          prepend-icon="mdi-cog"
          :title="$t('nav.config')"
          value="admin-config"
          to="/admin/config"
          @click="closeDrawer"
        />
        
        <v-list-item
          prepend-icon="mdi-security"
          :title="$t('admin.authTools.title')"
          value="admin-auth-tools"
          to="/admin/auth-tools"
          @click="closeDrawer"
        />
        
        <v-list-item
          prepend-icon="mdi-database"
          :title="$t('admin.database.title')"
          value="admin-database"
          to="/admin/database"
          @click="closeDrawer"
        />
      </template>
    </v-list>
    
    <template v-slot:append>
      <div class="pa-2">
        <v-list density="compact" nav>
          <v-list-item
            prepend-icon="mdi-logout"
            :title="$t('auth.logout')"
            @click="logout"
          />
        </v-list>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const router = useRouter()
const authStore = useAuthStore()

// Expose drawer model for parent component
const drawer = defineModel<boolean>('drawer', { default: false })

const closeDrawer = () => {
  drawer.value = false
}

const logout = () => {
  authStore.logout()
  closeDrawer()
  router.push('/')
}
</script>